const rankingItems = [
  { rank: 1, title: '星辰大海', type: '都市情感剧', heat: '9.8', trend: 'up', change: '+2' },
  { rank: 2, title: '长安夜未央', type: '古装权谋剧', heat: '9.7', trend: 'up', change: '+1' },
  { rank: 3, title: '迷雾追踪2', type: '悬疑推理剧', heat: '9.5', trend: 'up', change: '+5' },
  { rank: 4, title: '欢乐集结号', type: '综艺娱乐', heat: '9.4', trend: 'stable', change: '0' },
  { rank: 5, title: '极速追击', type: '动作电影', heat: '9.2', trend: 'down', change: '-1' },
  { rank: 6, title: '星辰变', type: '国漫动画', heat: '9.1', trend: 'up', change: '+3' },
];

export default function Ranking() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-600 text-sm"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
    return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
  };

  const getChangeColor = (change: string) => {
    if (change.startsWith('+')) return 'text-accent-600';
    if (change.startsWith('-')) return 'text-foreground-400';
    return 'text-foreground-400';
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            热门排行
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频实时热度排行，看看本周最受欢迎的影视内容
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
                } hover:bg-background-100/60 transition-colors cursor-pointer`}
              >
                <div className="w-8 flex-shrink-0 text-center">
                  {item.rank <= 3 ? (
                    <span
                      className={`inline-flex w-7 h-7 items-center justify-center rounded-lg text-sm font-bold ${
                        item.rank === 1
                          ? 'bg-primary-500 text-background-50'
                          : item.rank === 2
                            ? 'bg-accent-400 text-background-50'
                            : 'bg-secondary-500 text-background-50'
                      }`}
                    >
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-bold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap truncate">
                      {item.title}
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-background-200/70 text-foreground-500 whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500 text-xs"></i>
                    <span className="text-sm font-bold text-accent-600">{item.heat}</span>
                  </div>
                  <div className={`flex items-center gap-0.5 text-xs font-medium ${getChangeColor(item.change)}`}>
                    {getTrendIcon(item.trend)}
                    <span>{item.change}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}